import { Heading } from "components/Theme/heading";
import type { GatewayAssetOut } from "kubb";
import type React from "react";

function formatPowerSource(value: string | null | undefined): string {
  switch (value) {
    case "battery":
      return "Battery";
    case "mains":
      return "Mains";
    default:
      return "Unknown";
  }
}

function formatMeterLimit(value: number | null | undefined): string {
  return value != null ? `${value} devices` : "Unknown";
}

export default function GatewayCapabilitiesDisplay(props: {
  gateway: GatewayAssetOut;
}): React.ReactElement | null {
  const capabilities = props.gateway.capabilities;

  return (
    <div>
      <Heading>Gateway Capabilities</Heading>
      <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-1 text-sm">
        <dt className="text-gray-500">Power Source</dt>
        <dd>{formatPowerSource(capabilities?.power_source)}</dd>

        <dt className="text-gray-500">Wired M-Bus Meter Limit</dt>
        <dd>{formatMeterLimit(capabilities?.wired_mbus_meter_limit)}</dd>

        <dt className="text-gray-500">Wireless M-Bus Meter Limit</dt>
        <dd>{formatMeterLimit(capabilities?.wireless_mbus_meter_limit)}</dd>
      </dl>
    </div>
  );
}
